import { redirect } from 'react-router-dom';
import bootConfig from 'utils/bootConfig';
import {
  canManageTools,
  canCreateLinks,
  canModifyLinks,
  canViewLinks,
  canEditTool,
} from 'utils/permissionHelper';

const { permissions } = bootConfig.authInfo;

const ACCESS_DENIED_PATH = '/ltiManagement/accessDenied';

/**
 * Loader to protect the create link route.
 * @returns Redirect to Access Denied page if the user does not have the necessary permissions.
 */
const createLinkLoader = async () => {
  if (canCreateLinks(permissions)) {
    return null;
  }
  return redirect(ACCESS_DENIED_PATH);
};

/**
 * Loader to protect the edit link route.
 * User must have the canManagePlatform (LTI13_MANAGE_PLATFORM) permission or
 * at least one of the following permissions:
 * - canModifyLinks (MEDIA_MODIFY)
 * - canReadLinks (MEDIA_READ)
 * - isReadonlyLinks
 * @returns Redirect to Access Denied page if the user does not have the necessary permissions.
 */
const editLinkLoader = async () => {
  if (canModifyLinks(permissions) || canViewLinks(permissions)) {
    return null;
  }
  return redirect(ACCESS_DENIED_PATH);
};

/**
 * Loader to protect the create tool route.
 * User must have either the canManagePlatform (LTI13_MANAGE_PLATFORM) permission or
 * at least one Manage Tool (LTI13_MANAGE_<TOOL>) permission.
 * @returns Redirect to Access Denied page if the user does not have the necessary permissions.
 */
const createToolLoader = async () => {
  if (canManageTools(permissions)) {
    return null;
  }
  return redirect(ACCESS_DENIED_PATH);
};

/**
 * Loader to protect the edit tool route.
 * @param request React Router request object used to get the tool id from the URL.
 * @returns Redirect to Access Denied page if the user does not have the necessary permissions.
 */
const editToolLoader = async ({ request }) => {
  const url = new URL(request.url);
  const regex = /\/ltimanagement\/tool\/([a-zA-Z0-9-]+)\/edit/;
  const match = url.pathname.match(regex);
  const toolId = match ? match[1] : '';

  if (toolId !== '' && canEditTool(permissions, toolId)) {
    return null;
  }
  return redirect(ACCESS_DENIED_PATH);
};

export { createLinkLoader, editLinkLoader, createToolLoader, editToolLoader };
